export default __webpack_public_path__ + "media/images/images/portfolio/width-600/portfolio-3-339492c673089009a8bcd26e872a2311.jpg";